// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"506":"0b8d26da","775":"e3f9761e","2954":"7eff0396","4487":"1bc64751","7296":"8105886d","8562":"7eff0396"}[chunkId] + ".chunk.css";
};